import { SUPPORT_CREATE } from "./types";

export const supportCreate = (data,onSuccess, onError) => {
  return {
    type: SUPPORT_CREATE,
    data,
    onSuccess,
    onError,
  };
};
